<template lang="pug">
.content
  .row
    .col-md-12.member.member-form
      div.box_header
        label.title Thêm mới thành viên
        .clearfix
      div.box-content
        .box-filter-member
          .form-group
            label.title-note Chọn thành viên bạn muốn mời tham gia
          .form-group
            label.control-label Tìm theo tên hiển thị
            Select2#filter.select2-style(:options="lstUsers" :settings="settingSelect2" @select="selectUserEvent($event)")
          .list-meber-selected
            .row
              .box-custom-padding
                .col-md-2.col-xs-4.box-item-friend(v-if="lstUsersSelected !== null && lstUsersSelected.length > 0" v-for="(userSelected, index) in lstUsersSelected")
                  templateInfo(:item='userSelected.user' @onClickRemove="onClickRemove")
        .box-public-member
          label.title-note Chọn các Cộng đồng bạn muốn mời các thành viên trên tham gia
          div(v-if="lstPCs !== null && lstPCs.length > 0" v-for="(item, index) in lstPCs")
            templateItem(:item='item' @onClickChecked="onClickChecked" v-if="item.classes.length > 0" :key="keyIncrement")
        .item-pc-bottom
          button.active(@click="createUserToPC") Thêm mới
          button(@click="cancelRequest") Huỷ yêu cầu
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import templateItem from './templateItem'
import templateInfo from './templateInfo'
import $ from 'jquery'
export default {
  components: {
    MdNotification,
    templateItem,
    templateInfo
  },
  data() {
    return {
      message: this.$t('home.comming_soon'),
      key_id: 0,
      loader: null,
      lstUsers: [],
      lstUsersSelected: [],
      lstPCs: [],
      lstClassesSelected: [],
      lstSucess: [],
      lstHistory: [],
      keyIncrement: 0,
      paramsDefault: this.$route.params,
      userID: this.$store.getters.user,
      settingSelect2: {
        escapeMarkup: this.buildInputSelect2,
        matcher: this.matchCustom,
        templateResult: this.formatFunction,
        containerCssClass: 'custom-container',
        dropdownCssClass: 'custom-dropdown'
      }
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    },
    onClickChecked(pcID, status, checkedToggle, lstClasses) {
      this.lstClassesSelected = this.lstClassesSelected.filter(item => item.id !== pcID)
      if (lstClasses.length > 0) this.lstClassesSelected.push({id: pcID, status: status, checked: checkedToggle, classes: lstClasses})
    },
    selectUserEvent(user) {
      this.lstUsersSelected.push(user)
      this.lstUsers = this.lstUsers.filter(item => item.id !== user.id)
    },
    onClickRemove(item) {
      this.lstUsersSelected = this.lstUsersSelected.filter(remove => remove.id !== item.id)
      this.lstUsers.push({id: item.id, text: item.fullname, user: item})
    },
    createUserToPC() {
      this.lstClassesSelected = this.lstClassesSelected.filter(item => item.checked === true)
      if (this.lstUsersSelected.length === 0) {
        this.showNotification('Bạn chưa chọn thành viên', 'danger', 'top', 'right', 7000)
      } else {
        var objPCs = this.lstPCs.filter(item => item.checked === true)
        if (Object.entries(objPCs).length === 0) {
          this.showNotification('Bạn chưa chọn cộng đồng', 'danger', 'top', 'right', 7000)
        } else if (this.lstClassesSelected.length === 0) {
          this.showNotification('Vui lòng chọn lớp muốn tham gia', 'danger', 'top', 'right', 7000)
        } else if (this.lstUsersSelected.length > 0) {
          this.show()
          this.saveData()
        }
      }
    },
    async saveData() {
      try {
        for (let index = 0; index < this.lstUsersSelected.length; index++) {
          const userID = this.lstUsersSelected[index].id
          if (userID !== null && userID !== '') {
            for (let index = 0; index < this.lstClassesSelected.length; index++) {
              const element = this.lstClassesSelected[index]
              const pcID = Number(element.id)
              const status = Number(element.status)
              const classes = element.classes
              await this.saveUserForPC(userID, pcID, status, classes)
            }
          }
        }
        this.loader.hide()
        this.paramsDefault = Object.assign(this.paramsDefault, {reload: 1})
        if (this.lstSucess.length > 0) {
          this.showNotification('Đã mời thành viên tham gia cộng đồng thành công', 'success', 'top', 'right', 7000)
          this.$router.push({name: 'member', params: this.paramsDefault})
        } else {
          this.$router.push({name: 'member', params: this.paramsDefault})
        }
      } catch (e) {
        this.loader.hide()
      }
    },
    async saveUserForPC(userID, pcID, position, classes) {
      if (pcID > 0 && position > 0 && classes.length > 0) {
        for (let index = 0; index < classes.length; index++) {
          const classID = classes[index].id
          // const classApproval = Number(classes[index].type_approval)
          // const classPrivate = classes[index].private
          const exerciseIDs = classes[index].exercise_ids
          var variables = {
            pc_id: pcID,
            classes_id: classID,
            user_id: userID,
            status: 2, // mặc định đã duyệt
            // status: (classApproval === 2 || classPrivate) ? 2 : 1,
            position: position
          }
          var result = await this.getUserJoinPC(pcID, classID, userID)
          if (result === null || result.length === 0) {
            await this.$apollo.mutate({
              mutation: gql(graphql.CREATE_USER_JOIN_TO_PC),
              variables: variables,
              update: (store, { data: { insert_pc_user } }) => {
                if (insert_pc_user.affected_rows) {
                  // assign bai tap cho user
                  this.assignExerciseUser(exerciseIDs, userID, classID)
                  // tao history log
                  this.lstSucess.push(userID)
                  var returnHistory = this.lstHistory.filter(h => h.pc_id === pcID && h.user_id === userID)
                  if (Object.entries(returnHistory).length === 0) {
                    this.lstHistory.push({pc_id: pcID, user_id: userID})
                    var returnData = this.lstPCs.filter(o => o.id === pcID)
                    var description = ''
                    if (returnData && returnData.length > 0) {
                      description = returnData[0].name
                    }
                    this.createHistoryPC(pcID, userID, 'CREATE', 'Tham gia vào PC ' + description)
                  }
                }
              }
            })
          } else {
            var objWhere = {
              pc_id: {_eq: pcID},
              classes_id: {_eq: classID},
              user_id: {_eq: userID}
            }
            var objInput = {
              status: 2, // mặc định đã duyệt
              // status: (classApproval === 2 || classPrivate) ? 2 : 1,
              position: position,
              is_delete: false,
              updated_by: this.$store.getters.user
            }
            await this.$apollo.mutate({
              mutation: gql(graphql.UPDATE_PC_USER_ALL),
              variables: {objWhere: objWhere, objInput: objInput},
              update: (store, { data: { update_pc_user } }) => {
                if (update_pc_user.affected_rows) {
                  // assign bai tap cho user
                  this.assignExerciseUser(exerciseIDs, userID, classID)
                  // tao history log
                  this.lstSucess.push(userID)
                  var description = ''
                  var returnData = this.lstPCs.filter(o => o.id === pcID)
                  if (returnData && returnData.length > 0) {
                    description = returnData[0].name
                  }
                  if (result && result.length > 0 && position !== result[0].position) {
                    var textPosition = ''
                    textPosition += Number(result[0].position) > 1 ? 'Trợ lý' : 'Học sinh'
                    textPosition += Number(position) > 1 ? ' => Trợ lý' : ' => Học sinh'
                    this.createHistoryPC(pcID, userID, 'POSITION', 'Thay đổi vai trò ' + textPosition + ' trong PC ' + description)
                  }
                  if (result && result.length > 0 && variables.status !== result[0].status) {
                    var textStatus = ''
                    textStatus += Number(result[0].status) > 1 ? 'Đã duyệt' : 'Chờ duyệt'
                    textStatus += Number(variables.status) > 1 ? ' => Đã duyệt' : ' => Chờ duyệt'
                    this.createHistoryPC(pcID, userID, 'POSITION', 'Thay đổi trạng thái duyệt ' + textStatus + ' trong PC ' + description)
                  }
                }
              }
            })
          }
        }
      }
    },
    async getUserJoinPC($pcID, $classID, $userID) {
      var variables = {
        pc_id: $pcID,
        classes_id: $classID,
        user_id: $userID
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.CHECK_USER_JOIN_PC),
        variables: variables
      })
      if (data && data.pc_user.length > 0) {
        return data.pc_user
      }
      return null
    },
    async checkExerciseUserExist($exerciseID, $userID, $classID) {
      var isExists = -1
      var objWhere = {
        exercise_id: {'_eq': $exerciseID},
        user_id: {'eq': $userID},
        class_id: {'_eq': $classID}
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.CHECK_EXERCISE_USER_EXIST2),
        variables: {
          where: objWhere
        }
      })
      if (data && data.exercise_user.length > 0) {
        // nếu is_delete tai khoan bi xoa
        isExists = data.exercise_user[0].is_delete ? 2 : 1
      } else isExists = 0
      return isExists
    },
    async assignExerciseUser(exerciseIDs, userID, classID) {
      if (exerciseIDs !== null && exerciseIDs.length > 0) {
        for (let i = 0; i < exerciseIDs.length; i++) {
          var isExists = await this.checkExerciseUserExist(parseInt(exerciseIDs[i]), userID, classID)
          if (isExists === 0) {
            let objInput = {
              exercise_id: parseInt(exerciseIDs[i]),
              user_id: userID,
              class_id: classID,
              created_by: this.$store.getters.user,
              updated_by: this.$store.getters.user
            }
            await this.$apollo.mutate({
              mutation: gql(graphql.CREATE_EXERCISE_USER),
              variables: {object: objInput}
            }).catch((error) => {
              this.loader.hide()
              if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                this.$router.go(0)
              }
              console.error(error.message)
            })
          } else if (isExists === 2) {
            let objWhere = {
              exercise_id: {_eq: parseInt(exerciseIDs[i])},
              user_id: {_eq: userID},
              class_id: {_eq: classID}
            }
            let objInput = {
              is_delete: false,
              updated_by: this.$store.getters.user
            }
            await this.$apollo.mutate({
              mutation: gql(graphql.UPDATE_EXERCISE_USER),
              variables: {objWhere: objWhere, objInput: objInput}
            }).catch((error) => {
              this.loader.hide()
              if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                this.$router.go(0)
              }
              console.error(error.message)
            })
          }
        }
      }
    },
    addMinutes(dt, minutes) {
      var now = new Date(dt.getTime() + minutes * 60000)
      return (now.getFullYear() + '-' + (((now.getMonth() + 1) < 10) ? ('0' + (now.getMonth() + 1)) : ((now.getMonth() + 1))) + '-' + (now.getDate()) + ' ' + now.getHours() + ':' + ((now.getMinutes() < 10) ? ('0' + now.getMinutes()) : (now.getMinutes())) + ':' + ((now.getSeconds() < 10) ? ('0' + now.getSeconds()) : (now.getSeconds())))
    },
    async createHistoryPC(pcID, userID, action, description) {
      var objInput = {
        pc_id: pcID,
        user_id: userID,
        action: action,
        name: 'TEACHER',
        description: description,
        access_time: this.addMinutes(new Date(), 10)
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.CREATE_PC_HISTORY),
        variables: {objInput: objInput}
      })
    },
    cancelRequest() {
      var paramsObject = this.$route.params
      paramsObject = Object.assign(paramsObject, {reload: 1})
      this.$router.push({name: 'member', query: this.$route.query, params: paramsObject})
    },
    buildInputSelect2() {
      var html = $(
        '<style>' +
          '@media (max-width: 1200px){.select2-container{width:100% !important;}}' +
          '.nav-open .select2-container{width:100% !important;}' +
          '.select2-container{margin-top: 0 !important;}' +
          '.select2-container .select2-selection--single{border-radius:10px;height:48px;}' +
          '.select2-container--default .select2-selection--single .select2-selection__arrow{display:none;}' +
          '.select2-selection__rendered{height: 100%; display:flex !important;}' +
          '.select2-selection__rendered span{display:block; width:100%;color: #B4B4B4; font-size:14px;align-items: center; display: inline-flex;}' +
          '.select2-selection__rendered span.results-message{display:none;}' +
          '.select2-results__message span.placeholder{display:none;}' +
          '.select2-results__message span.results-message{display:block;padding: 0 16px 16px;}' +
          '.custom-dropdown .select2-search{margin: 16px;padding:0;position: relative;}' +
          '.select2-search--dropdown .select2-search__field, .custom-dropdown .select2-search__field{background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #838F9F;border-radius: 10px; padding-left:10px; }' +
          '.custom-dropdown .select2-search:after{content: "" ; color: #2759AE; background: url("' + require('../../assets/images/faces/search.svg') + '") 0 0 no-repeat;height: 16px; position: absolute; right: 12px; top: 8px; width: 16px;}' +
          '.select2-results__option{padding: 6px 0;}' +
          '.select2-container--open .select2-dropdown{background: #F2F2F2 0% 0% no-repeat padding-box; box-shadow: 0px 3px 6px #00000029;border-radius: 10px;margin-top:-48px;}' +
        '</style>' +
        '<span class="placeholder">Tìm theo tên hiển thị, email</span>' +
        '<span class="results-message">Không có dữ liệu</span>'
        )
      return html
    },
    formatFunction(item) {
      if (item.user && item.user !== null) {
        var avatar = item.user.avatar !== null ? item.user.avatar : require('../../assets/images/faces/ic_AvatarDefault.svg')
        var type = this.typeRealationUser(item.user.type)
        var html = $(
          '<style>' +
            '.select2-dropdown{background: #F2F2F2 0% 0% no-repeat padding-box;}' +
            '.custom-dropdown{margin-top: -48px; background: #F2F2F2 0% 0% no-repeat padding-box;box-shadow: 0px 3px 6px #00000029;border-radius: 10px !important; padding: 15px 0;} ' +
            '.custom-dropdown .select2-search{margin: 0 16px 16px;padding:0;position: relative;}' +
            '.select2-search--dropdown .select2-search__field, .custom-dropdown .select2-search__field{background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #838F9F;border-radius: 10px; padding-left:10px; }' +
            '.custom-dropdown .select2-search:after{content: "" ; background: url("' + require('../../assets/images/faces/search.svg') + '") 0 0 no-repeat;height: 16px; position: absolute; right: 12px; top: 8px; width: 16px;}' +
            '.select2-results__option--highlighted .item-filter span {color:#fff !important;}' +
            '.select2-container--default .select2-results .select2-results__options {max-height: 300px;overflow-y: auto;}' +
            '.item-filter{display:flex; margin: 0 9px;}' +
            '.item-filter-img{width: 48px; height: 48px; margin-right: 10px; margin: 0 auto; border-radius: 50%; overflow: hidden; justify-content: center;}' +
            '.item-filter-img img {width: 100%; height: auto; object-fit: cover;}' +
            '.item-filter-info{width: calc(100% - 50px); margin-left: 10px;}' +
            '.item-filter:hover span {color:#fff !important;}' +
            '.item-filter-info span{font-size:15px; display:block;color: #333333;margin-bottom:4px; text-align: left;}' +
            '.item-filter-info span.last{color: #969FAD; font-size:13px; display:block;}' +
            'svg {color: blue;}' +
          '</style>' +
          '<div class="item-filter">' +
          '<div class="item-filter-img"><img src="' + avatar + '"/> </div>' +
          '<div class="item-filter-info"><span>' + item.user.fullname + '</span><span class="last">' + type + '</span></div>' +
          '</div>')
        return html
      }
    },
    typeRealationUser(type) {
      var html = 'Default'
      switch (type) {
        case 1:
          html = 'Bạn bè'
          break
        case 2:
          html = 'Bạn đồng hành'
          break
        case 3:
          html = 'Giáo viên'
          break
      }
      return html
    },
    matchCustom(params, data) {
      if ($.trim(params.term) === '') {
        return data
      }
      if (typeof data.text === 'undefined') {
        return null
      }
      if (data.text.trim().toLowerCase().indexOf(params.term.trim().toLowerCase()) > -1 || data.user.email.indexOf(params.term) > -1) {
        var modifiedData = $.extend({}, data, true)
        return modifiedData
      }
      return null
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    }
  },
  beforeDestroy() {
  },
  async created () {
    const {data} = await this.$apollo.query({
      query: gql(graphql.GET_RELATION_OF_USER),
      variables: {
        user_id: this.userID,
        status: 2,
        type: [1, 2]
      }
    })
    if (data.relation && data.relation.length > 0) {
      var userRelation = []
      for (let index = 0; index < data.relation.length; index++) {
        const item = data.relation[index]
        var userObject = item.userRequested
        if (item.user_id_request === this.userID) {
          userObject = Object.assign(userObject, {type: item.type})
          userRelation.push({id: item.user_id_requested, text: userObject.fullname, user: userObject})
        } else if (item.user_id_requested === this.userID) {
          userObject = item.userRequest
          userObject = Object.assign(userObject, {type: item.type})
          userRelation.push({id: item.user_id_request, text: userObject.fullname, user: userObject})
        }
      }
      this.lstUsers = userRelation
    }
  },
  apollo: {
    lstPCs: {
      query: gql(graphql.GET_USER_JOIN_PC_MEMBER),
      variables() {
        return {
          user_id: this.$store.getters.user,
          order_by: {updated_at: 'desc', name: 'asc'}
        }
      },
      update: data => {
        return data.private_community
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.box_header{
  .title{text-align: left; font-size: 20px; font-weight: bold; letter-spacing: 0px;color: #5F6468;}
}
.member-form{
  .box-content{margin-top: 15px;
    .title-note{color: #9F6A28;text-transform: uppercase; font-weight: bold !important; font-size: 15px;margin-bottom: 8px;}
    .form-group{padding: 0; margin: 0;
      label{font-weight: normal;}
      .box-container-filter{position: relative;
        .input-filter{cursor: pointer; height: 48px; background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #B4B4B4;border-radius: 10px;}
      }
    }
    .box-filter-member{ margin-bottom: 24px;
      .list-meber-selected{
        .box-custom-padding{float: left; width: 100%;padding-left: 8px; padding-right: 8px;
          .box-item-friend{margin-top: 15px; padding-left: 8px; padding-right: 8px;}
        }
      }
    }
    .box-public-member{
      .title-note{margin-bottom: 16px;}
      .item-public-member{padding: 15px; border-radius: 10px; background: #fff; margin-bottom: 16px;
        .item-checkbox{display:inline-flex; width: 30px;justify-content: center;align-items: center;
          input{display:none;}
          input + label{cursor: pointer;background: url("../../assets/images/faces/ic_check_box_outline@2x.png") no-repeat center center;height: 20px;width: 20px;display:inline-block; background-size: cover; margin: 0;}
          input:checked + label{cursor: pointer;background: url("../../assets/images/faces/ic_check_box@2x.png") no-repeat center center;height: 20px;width: 20px;display:inline-block;background-size: cover;}
        }
        .item-top-board{display: flex;justify-content: center; align-items: center; margin-bottom: 10px;
          .board-img{width: 16px; height: 16px; margin: 0 auto; border-radius: 50%; display: inline-flex;overflow: hidden; justify-content: center;
            img{max-width: 100%; height: auto; object-fit: cover;}
          }
          .board-info{ width: calc(100% - 200px); display: inline-flex; margin-left: 8px;
            span{font-size: 15px; font-weight: bold; display: block;}
          }
          .borard-check{display: inline-flex; width: 170px;
            span {color: #333333; font-size: 15px;}
          }
        }
      }
    }
    .item-pc-bottom{
      button{margin: 0; height: 48px; width: 120px; border: 0 none; border-radius: 5px; font-size: 14px; display: inline-block; color: #23180A;
        &.active{background: #FFD311 0% 0% no-repeat padding-box;margin-right: 30px;}
      }
    }
  }
}
@media (max-width: 1366px){
  
}
@media (max-width: 1024px){
  
}
@media (max-width: 991px){
}
@media (max-width: 767px){
  
}
@media (max-width: 560px){
 
}
</style>



// WEBPACK FOOTER //
// add.vue?b8bdd296